import type { AnyPosition } from './types';
import { determineStandardAssetClass } from '@/utils/asset-class';

export function mapPositionToAssetType(position: AnyPosition): string {
  // Prefer explicit asset_type from DB-backed positions
  if ('asset_type' in position && typeof position.asset_type === 'string' && position.asset_type) {
    return determineStandardAssetClass(undefined, position.asset_type);
  }
  const securityType = 'securityType' in position && typeof position.securityType === 'string'
    ? position.securityType.toLowerCase()
    : '';
  const name = 'name' in position && typeof (position as any).name === 'string'
    ? ((position as any).name as string).toLowerCase()
    : '';

  let guess: string = 'unclassified';
  if (securityType.includes('cash') || name.includes('cash') || securityType.includes('money market') || name.includes('money market')) {
    guess = 'cash';
  } else if (securityType.includes('multi') || securityType.includes('mixed') || name.includes('multi') || name.includes('mixed')) {
    guess = 'multi_asset';
  } else if (securityType.includes('bond') || securityType.includes('fixed') || securityType.includes('income') || name.includes('bond')) {
    guess = 'fixed_income';
  } else if (securityType.includes('stock') || securityType.includes('equity') || name.includes('stock') || name.includes('equity')) {
    guess = 'equity';
  }

  return determineStandardAssetClass(undefined, guess);
}
